import { formatLocation } from "@/utils/text";

export const LocationText = ({ city, state, className }) => {
    if (!city || !state) {
        return <span className={className}>-</span>;
    }

    return <span className={className}>{formatLocation(city, state)}</span>;
};
